import React from "react";
import classnames from "classnames";
import s from "./Burger.module.scss";
const Burger = _ref => { let { handleStateChange, menuOpen } = _ref; const handleClick = e => { handleStateChange(); }; const styles = classnames(s.wrap, { [s.open]: menuOpen }); return /*#__PURE__*/ React.createElement("div", { className: styles, onClick: handleClick }, /*#__PURE__*/ React.createElement("span", null), /*#__PURE__*/ React.createElement("span", null), /*#__PURE__*/ React.createElement("span", null)); };
export default Burger;
